import React, { useState, useEffect } from 'react'
import { useField } from 'formik'
import ReactAsyncMultiselectField from 'components/molecules/react-async-multiselect-field'
import CmsBlogPostCategoriesApiV2 from 'api/v2/admins/cms-blog-post-categories-api-v2'
import CmsBlogPostsApiV2 from 'api/v2/admins/cms-blog-posts-api-v2'
import { useParams } from 'react-router'

import PropTypes from 'prop-types'

const propTypes = {
  label        : PropTypes.string,
  placeholder  : PropTypes.string,
  isEditAction : PropTypes.bool,
  required     : PropTypes.bool
}

const defaultProps = {
  label        : '',
  placeholder  : '',
  isEditAction : false,
  required     : false
}

/**
 * Allow multi select options for categories.
 * Only to be used within a Formik component
 * @param {string} label - Field label
 * @param {string} placeholder - Field placeholder
 * @param {bool} required - Required badge will show if it set true
 */
const CategoryAsyncMultiselectField = ({
  label,
  placeholder,
  isEditAction,
  required,
  ...props
}) => {

  const [ inputValue, setInputValue ]     = useState('')
  const [ dataSelected, setDataSelected ] = useState([])
  const { id }                            = useParams()

  useEffect(() => {
    if (isEditAction){
      CmsBlogPostsApiV2.getSingle(id)
        .then((response) => {
          const initialCategories = []

          response.data.blog_post.category.map((category, index) => {
            const initialCategory = {}
            initialCategory['id'] = index
            initialCategory['name'] =  category

            initialCategories.push(initialCategory)

            if (initialCategories.length >= 1)  {
              setDataSelected([ ...dataSelected, ...initialCategories ])
            }
          })

        })
        .catch(() => 'Unable to fetch blog post categories. Please reload the page.')
    }

    if (!field.value) return
    let currentValue = field.value.toString()

    if (currentValue !== '') {
      let categoriesOption = CmsBlogPostCategoriesApiV2.get(inputValue)
        .then((response) => response.data.categories)

      if (categoriesOption.length >= 1)  {
        setDataSelected([ ...dataSelected, ...categoriesOption ])
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  // * Do this to get helper object from useField
  // eslint-disable-next-line no-unused-vars
  const [ field, meta, helper ] = useField(props)

  const loadOptions = async () => {
    let result =CmsBlogPostCategoriesApiV2.get(inputValue)
      .then((response) => response.data.categories)

    return result
  }

  // The presentation of option label when dropdown is open
  const getOptionLabel = (option) => (
    option.name
  )

  const handleCustomChange = (options) => {

    // * prevent undefined value
    if (options) {

      // * set specific value to the formikBag.values
      const optionValue = options.map((options) => options.name)
      const joinValue   = optionValue.join(',')
      helper.setValue(joinValue)
    }
    else {
      // * we should keep update the formik value
      // * If user remove all options, we update to empty array
      helper.setValue('')
    }
    setDataSelected(options)
  }

  return (
    <ReactAsyncMultiselectField
      name={ field.name }
      label={ label }
      placeholder={ placeholder }
      required={ required }
      loadOptions={ loadOptions }
      getOptionLabel={ getOptionLabel }
      setInputValue={ setInputValue }
      handleCustomChange={ handleCustomChange }
      dataSelected={ dataSelected }
      { ...props }
    />
  )
}

CategoryAsyncMultiselectField.propTypes    = propTypes
CategoryAsyncMultiselectField.defaultProps = defaultProps

export default CategoryAsyncMultiselectField
